export default __webpack_public_path__ + "f19d5eb.png";